import React, { ReactElement } from "react";
import HubCategoryDetails from "../../../components/Hubs/Categories/details";
import Layout from "../../../components/layout";

const HubCategoryDetailsPage = (): ReactElement => {
  return (
    <Layout>
      <HubCategoryDetails />
    </Layout>
  );
};

export default HubCategoryDetailsPage;
